import { useTranslation } from 'react-i18next'
import type { SubscriptionItem } from '@/hooks/useSubscription'

/**
 * EP-144: the one place a subscription engine line turns into a sentence.
 *
 * The engine emits `description_key` + `description_params` rather than a
 * rendered string (C-15) so mail and web each localize it themselves. The tier
 * card (next-invoice preview) and the invoice detail page both render the same
 * shape, so the recipe lives here: localizing the same key two different ways
 * in two files is how the estimate and the issued invoice start disagreeing.
 *
 * The `tier` param is itself an enum value with its own label, so it is
 * translated BEFORE it is interpolated (otherwise the line reads
 * "ค่าบริการ standard").
 */
export function useSubscriptionItemLabel() {
  const { t } = useTranslation('settings')

  return (item: SubscriptionItem) => {
    const params: Record<string, string | number> = { ...item.description_params }
    if (typeof params.tier === 'string') {
      params.tier = t(`subscription.tiers.${params.tier}`)
    }
    return t(`subscription.items.${item.description_key}`, params)
  }
}
